import React, { Component } from 'react';
import _ from 'lodash';

import ReactDOM from 'react-dom';

import moment from 'moment';

import style from './style.scss';



import LeadsListCallbacks from '../LeadsCallbacks/LeadsListCallbacks';

export default class LeadsCallbacksPage extends Component{

  constructor(props) {
    super(props);

    this.state = {
    };

  }


  componentWillMount(){

    const {app_data, history} = this.props;

    const role = app_data.roles[app_data.user.role_id];

    if(!role.access.callbacks) {
      history.push(role.default_page);
    }

  }


  render() {

    const {app_data} = this.props;




    return (
      <div className={`container`}>

        <h1>Лист обзвона</h1>

        <LeadsListCallbacks app_data={app_data} />



      </div>
    );
  }
}

